import React from 'react';
import { ReadOnlyGuard, SparkIcon, TagGeneral, TooltipTrigger } from '@spark';

/**
 * Model column headers (Figma 1314:58742): "Playground" title in the input
 * column, then one white card per model with name, type tag, and swap / close
 * actions.
 *
 * Optional `onBack` renders the same "← Back" control as the task-creation
 * wizard, absolutely positioned in the left gutter so the title does not
 * shift.
 */
const ModelHeadersRow = ({ slots, onSwapModel, onRemoveModel, teacherModelId, onBack }) => (
    <div className="pg-headers-row fs-unmask">
        <div className="pg-headers-row__title-col">
            {onBack && (
                <button type="button" className="pg-back-button" onClick={onBack}>
                    <SparkIcon slug="arrow-left" size="small" />
                    <span>Back</span>
                </button>
            )}
            <span className="pg-headers-row__title">Playground</span>
        </div>
        {slots.map((slot) => {
            const isTeacher = !!teacherModelId && slot.model === teacherModelId;
            const tagLabel = isTeacher
                ? 'Teacher'
                : slot.provider === 'specificai'
                    ? 'Specific'
                    : 'Commercial';
            return (
                <div className="pg-model-header" key={slot.slotId}>
                    <div className="pg-model-header__row1">
                        <TooltipTrigger text={slot.displayName || ''} placement="bottom">
                            <span className="pg-model-header__name">
                                {slot.displayName || 'Select a model'}
                            </span>
                        </TooltipTrigger>
                        <TagGeneral label={tagLabel} />
                        <span className="pg-model-header__spacer" />
                        {slot.provider !== 'specificai' && !isTeacher && (
                            <ReadOnlyGuard>
                                <TooltipTrigger text="Replace task model" placement="bottom">
                                    <button
                                        type="button"
                                        className="pg-model-header__action"
                                        aria-label="Replace task model"
                                        onClick={() => onSwapModel(slot)}
                                    >
                                        <SparkIcon slug="switch-horizontal" size="small" />
                                    </button>
                                </TooltipTrigger>
                            </ReadOnlyGuard>
                        )}
                        <TooltipTrigger text="Remove model" placement="bottom">
                            <button
                                type="button"
                                className="pg-model-header__action"
                                aria-label="Remove model"
                                onClick={() => onRemoveModel(slot)}
                            >
                                <SparkIcon slug="close" size="small" />
                            </button>
                        </TooltipTrigger>
                    </div>
                </div>
            );
        })}
    </div>
);

export default ModelHeadersRow;
